import type { NavigationOptions } from '@/models/Ou';

export type NavigationBtn = {
  label: string;
  value: keyof NavigationOptions;
  channels: boolean;
  apps: boolean;
  custom?: boolean;
  flag?: string; // required flag to work
  children?: NavigationBtn[];
};

export const NewDefaultNavigationBtns: NavigationBtn[] = [
  {
    label: 'Dashboards',
    value: 'dashboards',
    channels: true,
    apps: true,
    children: [
      { label: 'Analytics', value: 'analytics', channels: true, apps: true },
      {
        label: 'Monitoring',
        value: 'monitoringDashboard',
        channels: true,
        apps: false,
        flag: 'enable-monitoring-dashboard-flag',
      },
      { label: 'Health', value: 'health', channels: false, apps: false },
      { label: 'Usage', value: 'usage', channels: false, apps: false },
      { label: 'Destinations', value: 'destinations', channels: false, apps: false },
      { label: 'App Analytics', value: 'app-analytics', channels: false, apps: true },
      {
        label: 'Streaming Analytics',
        value: 'streaming-analytics',
        channels: true,
        apps: false,
      },
    ],
  },
  { label: 'Upload Assets', value: 'uploadAssets', channels: true, apps: true }, // done
  { label: 'Asset Library', value: 'assetLibrary', channels: true, apps: true }, // done
  { label: 'Channel Manager', value: 'channelManager', channels: true, apps: true }, // done
  {
    label: 'Live',
    value: 'live',
    channels: true,
    apps: true,
    children: [
      { label: 'Stream Key Setup', value: 'livePrograms', channels: true, apps: false }, // done
      { label: 'Inputs Scheduler', value: 'inputs', channels: true, apps: false, flag: 'input-page-ui-feature-enabled' }, // done
      { label: 'App Events', value: 'appEvents', channels: false, apps: true },
      { label: 'Live Guide', value: 'liveGuide', channels: false, apps: true },
    ],
  },
  {
    label: 'Content',
    value: 'content',
    channels: false,
    apps: true,
    children: [
      { label: 'Movies', value: 'movies', channels: false, apps: true },
      { label: 'Series', value: 'series', channels: false, apps: true },
    ],
  },
  {
    label: 'Monetization',
    value: 'monetization-dropdown',
    channels: true,
    apps: false,
    children: [
      { label: 'Ad Tag Management', value: 'monetization', channels: true, apps: false, flag: 'fuel-ui-show-self-service-ads' },
      { label: 'Products', value: 'products', channels: false, apps: false },
      { label: 'Coupons', value: 'productCoupons', channels: false, apps: false },
    ],
  },
  {
    label: 'Marketing',
    value: 'marketing',
    channels: false,
    apps: true,
    children: [
      { label: 'Push Notifications', value: 'pushNotifications', channels: false, apps: true },
      // { label: 'Mailchimp', value: 'mailchimp', channels: false, apps: false },
      // { label: 'Firebase', value: 'firebase', channels: false, apps: false },
    ],
  },
  { label: 'App Users', value: 'appUsers', channels: true, apps: true },
  {
    label: 'Settings',
    value: 'settings',
    channels: true,
    apps: true,
    children: [
      { label: 'Admin (Legacy)', value: 'settings-admin', channels: true, apps: true },
      { label: 'Admin', value: 'admin', channels: true, apps: true },
      { label: 'Advanced Admin', value: 'advancedAdmin', channels: false, apps: false },
      { label: 'OU Navigation', value: 'ouNavigation', channels: true, apps: false },
      { label: 'MRSS Feed Config', value: 'mrssFeedConfig', channels: false, apps: false },
      { label: 'MRSS Mapper', value: 'mrssMapper', channels: false, apps: false },
      { label: 'Global Interstitials', value: 'globalInterstitials', channels: true, apps: false }, // done
      { label: 'Automated Transitions', value: 'transitionPackages', channels: true, apps: false }, // done
      { label: 'Event Workflows', value: 'eventWorkflows', channels: true, apps: false }, // done
    ],
  },
  { label: 'App Settings', value: 'site', channels: false, apps: true },
  {
    label: 'Workflow Config',
    value: 'workflowConfig',
    channels: false,
    apps: false,
  },
  {
    label: 'Account',
    value: 'account-dropdown',
    channels: true,
    apps: true,
    children: [
      { label: 'CMS Users', value: 'account', channels: true, apps: true },

      { label: 'Billing', value: 'billing', channels: false, apps: false },
      { label: 'Account Activity', value: 'accountActivity', channels: false, apps: false },
    ],
  },
  { label: 'Divider', value: 'divider', channels: true, apps: false },
  { label: 'Onboarding', value: 'onboarding', channels: false, apps: false },
  {
    label: 'ViewNexa Assistant',
    value: 'viewNexaAssistant',
    channels: true,
    apps: false,
    flag: 'view-nexa-support-chatbot',
  },
  { label: 'Help', value: 'help', channels: true, apps: false },
];
